__turbopack_context__.v({
  "bottomComponent": "CoverImage-module-scss-module__lkbA5G__bottomComponent",
  "container": "CoverImage-module-scss-module__lkbA5G__container",
  "dropdown": "CoverImage-module-scss-module__lkbA5G__dropdown",
  "footerShadow": "CoverImage-module-scss-module__lkbA5G__footerShadow",
  "footerText": "CoverImage-module-scss-module__lkbA5G__footerText",
  "iconContainer": "CoverImage-module-scss-module__lkbA5G__iconContainer",
  "image": "CoverImage-module-scss-module__lkbA5G__image",
  "imageWrapper": "CoverImage-module-scss-module__lkbA5G__imageWrapper",
  "placeholder": "CoverImage-module-scss-module__lkbA5G__placeholder",
  "subtitle": "CoverImage-module-scss-module__lkbA5G__subtitle",
  "titleContainer": "CoverImage-module-scss-module__lkbA5G__titleContainer",
  "uploadBtn": "CoverImage-module-scss-module__lkbA5G__uploadBtn",
});
